import React from 'react';
import { Dropdown } from 'react-bootstrap';

import '../coldemailer.css';
import '../coldemailer-styles.css';

// A native select's open list is painted by the browser, so its highlight colour cannot be
// styled from the page. This renders the list as real elements instead, which is the only way
// to control how the selected and hovered rows look.
//
// Takes the same value/onChange shape as Form.Select, so call sites read the same way, and the
// options are the same { value, label } objects.
function NDSelect({ options, value, onChange, disabled, className, size }) {

	const get_selected_label = () => {
		for(var option_index = 0; option_index < options.length; ++option_index) {
			if(String(options[option_index].value) === String(value)) {
				return options[option_index].label;
			}
		}

		return '';
	};

	// Mirrors an event so a caller written against Form.Select needs no changes
	const handle_select = (selected_value) => {
		if(!onChange) {
			return;
		}

		onChange({ target: { value: selected_value } });
	};

	const build_class = () => {
		if(className) {
			return 'nd-select ' + className;
		}

		return 'nd-select';
	};

	const render_item = (option) => {
		const is_active = String(option.value) === String(value);

		return (
			<Dropdown.Item
				key={option.value}
				eventKey={option.value}
				active={is_active}
				className="nd-select-item"
			>
				{option.label}
			</Dropdown.Item>
		);
	};

	return (
		<Dropdown className={build_class()} onSelect={handle_select}>
			<Dropdown.Toggle
				size={size}
				disabled={disabled}
				className="nd-select-toggle"
			>
				{get_selected_label()}
			</Dropdown.Toggle>

			<Dropdown.Menu className="nd-select-menu">
				{options.map(render_item)}
			</Dropdown.Menu>
		</Dropdown>
	);
}

export default NDSelect;
